import gsap from 'gsap'

export default class {
  constructor({ scroller, selector }) {
    this.locoScroller = scroller
    this.selector = selector
    this.hidden = false
    this.header = document.querySelector(this.selector)

    if (this.header) {
      gsap.set(this.selector, { y: 0 })
      this.headerHeight = this.header.getBoundingClientRect().height
      this.menuTrigger = document.querySelector('.menu__trigger')
      this.mobileMenu = document.querySelector('.mobile__menu')
      this.scroll = {
        current: 0,
        target: 0,
      }
      //Methodes
      this.initHeader()
      this.show()
    }

    this.initTimeLine()
    this.addEventListeners()
  }

  addEventListeners() {

    this.menuTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      //       
      this.toggleMenu()
    })

    this.mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        //
        // this.toggleMenu().then(() => { setTimeout(() => this.locoScroller.scrollTo(document.querySelector(e.target.hash)), 1000) })
        this.toggleMenu()
        // 
      })
    })

  }


  toggleMenu() {
    if (this.header.classList.contains('menuOpen')) {
      this.locoScroller?.start()
      this.tl.reverse()
    } else {
      this.locoScroller?.stop()
      this.tl.play()
    }
    this.header.classList.toggle('menuOpen')
    return Promise.resolve()
  }

  initTimeLine() {
    this.tl = gsap.timeline({
      paused: true,
    })
    // this.tl.to(this.header, {
    //   background: '#3f1c8e'
    // })
    this.tl.to(this.mobileMenu, {
      x: "0%",
      duration: 0.6,
      ease: 'Poweer2.easeOut'
    })

  }

  hideHeader() {
    if (this.scroll.target > (this.headerHeight + 100)) {
      gsap.to(this.header, {
        y: '-100%',
        duration: 1,
        ease: 'Power2.easeOut',
      })
      this.hidden = true
    }
  }

  showHeader() {
    gsap.to(this.header, {
      y: 0,
      duration: 1,
      ease: 'Power2.easeOut',
    })
    this.hidden = false
  }

  initHeader() {

    const links = document.querySelectorAll('.header__nav a,.footer__nav a')
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        links.forEach(el => el.classList.remove('is__active'))
        Array.from(links).filter(el => el.dataset.id === e.target.dataset.id).forEach(el => el.classList.add('is__active'))
      })
    })
    //    
    
    if (this.locoScroller) {
      this.locoScroller.on('scroll', (instance) => {        
        // this.scroll.target = instance.scroll.y
        this.scroll.target = window.pageYOffset
        if (instance.direction === 1 && !this.hidden) {          
          this.hideHeader()
        }

        if (instance.direction === -1 && this.hidden) {
          this.showHeader()
        }

      })
    } else {

      window.addEventListener('scroll', () => {
        this.scroll.target = window.pageYOffset
        if (this.scroll.current < this.scroll.target && !this.hidden) {
          this.hideHeader()
        } else if (this.scroll.current > this.scroll.target && this.hidden) {
          this.showHeader()
        }
        this.scroll.current = this.scroll.target
      })
    }
  }

  addEventListener() {
    document.addEventListener('resize', this.onResize)
  }


  show() {
    gsap.to(this.header, {
      top: 0,
      duration: 1
    })
  }

}